module.exports = __webpack_public_path__ + "static/img/40.a733cd6d.png";